import { render, staticRenderFns } from "./UrunGrid.vue?vue&type=template&id=c210f490&scoped=true"
import script from "./UrunGrid.vue?vue&type=script&lang=js"
export * from "./UrunGrid.vue?vue&type=script&lang=js"
import style0 from "./UrunGrid.vue?vue&type=style&index=0&id=c210f490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c210f490",
  null
  
)

export default component.exports